<template>
  <div>
    propertyOther
  </div>
</template>

<script>
export default {
  name: 'propertyOther',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>